import { render, staticRenderFns } from "./formButton.vue?vue&type=template&id=e712c566&scoped=true"
import script from "./formButton.vue?vue&type=script&lang=js"
export * from "./formButton.vue?vue&type=script&lang=js"
import style0 from "./formButton.vue?vue&type=style&index=0&id=e712c566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e712c566",
  null
  
)

export default component.exports